import React from "react";
import Button from '@material-ui/core/Button';

 const SignUpButton = props =>  {
    console.log(props)
        return (
            <div>

            <Button  variant="contained" color="primary"
                style={{marginTop:"6%",width:"100%"}}>
                {props.buttonname}
            </Button> 
            </div>

        );

    }
// export const Button=props=>{
//     console.log(props)
//     return (
//         <div>

//         <Button  variant="contained" color="#FFFFFFF"
//             style={{marginTop:"3%",width:"100%"}}>
//             {props.buttonname}
//         </Button> 
//         </div>

//     );
// }


 export default SignUpButton;